import { Package } from "lucide-react";

type OrderEmptyStateProps = {
  hasFilters: boolean;
  onClearFilters?: () => void;
};

export function OrderEmptyState({
  hasFilters,
  onClearFilters,
}: OrderEmptyStateProps) {
  return (
    <div className="order-empty-state">
      <div className="order-empty-state-icon" aria-hidden>
        <Package size={24} strokeWidth={1.5} />
      </div>
      <p className="order-empty-state-title">
        {hasFilters ? "Nenhum pedido encontrado" : "Nenhum pedido ainda"}
      </p>
      {hasFilters && onClearFilters ? (
        <button
          type="button"
          className="order-empty-state-clear"
          onClick={onClearFilters}
        >
          Limpar filtros
        </button>
      ) : null}
    </div>
  );
}
